module.exports = __webpack_public_path__ + "static/media/sub_superlike.c44809e7.png";